import type { OrderTag } from '@/features/trackOrder/domain/enums/OrderTag'
import type { UserAddressType } from '@/features/user/domain/enums/UserAddressType'
import type { LngLatEntity } from '@/shared/entities/LngLatEntity'

export class ShipmentCustomerEntity {
  userId?: string
  userDisplayName?: string | null
  userPhoneNumber?: string | null
  userPhotoUrl?: string | null
  destination?: LngLatEntity
  destinationName?: string | null
  homeNumber?: string | null
  addressType?: UserAddressType
  description?: string | null
  tags?: OrderTag[]
}
